import D2aTable from './D2aTable.component';

export default D2aTable;
